import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import Home from "@/views/Home";
import Login from "@/components/Login/LoginPage";
import LoginCompanySelection from "@/components/Login/LoginCompanySelection";
import LoginRecoveryEmail from "@/components/Login/LoginRecoveryEmail";
import LoginPasswordRecovery from "@/components/Login/LoginPasswordRecovery";
import recovery from "@/views/recovery/recovery";
import recoveryStep2 from "@/views/recovery/recovery-step-2";
import recoveryStep3 from "@/views/recovery/recovery-step-3";
import Hub from "@/views/Hub";

import NpvTable from "@/components/Npv/NpvTable"
import ConfigurationNpv from "@/components/Npv/Configuration/Npv"
import NpvConfiguration from "@/components/Npv/NpvConfiguration"

import DashboardPage from "@/components/BusinessIntelligenceManagement/Dashboards/DashboardPage";
import Workspace from "@/components/ProjectManagement/Workspaces/Workspace";
import ImportsView from "@/views/ImportsView.vue";

import DeleteLayers from "@/views/DeleteLayers.vue"

import SimulationsManagement from "@/views/Npv";

import SystemManagement from "@/views/SystemManagement";
import AccountRoles from '@/views/AccountRolesView'
import Roles from "@/components/SystemManagement/Accounts/ClientRoles/ClientRole";
import RoleCreate from "@/components/SystemManagement/Accounts/ClientRoles/ClientRoleCreate";
import RoleEdit from "@/components/SystemManagement/Accounts/ClientRoles/ClientRoleEdit";
import RoleView from "@/components/SystemManagement/Accounts/ClientRoles/ClientRoleView";
import ListInfo from "@/components/SystemManagement/SystemSettings/ListsSettings/ListInfo";
import ListsSettingsPage from "@/components/SystemManagement/SystemSettings/ListsSettings/ListsSettingsPage";
import NewCustomList from "@/components/SystemManagement/SystemSettings/ListsSettings/NewCustomList";
import UpdateList from "@/components/SystemManagement/SystemSettings/ListsSettings/UpdateList";
import UpdateListItem from "@/components/SystemManagement/SystemSettings/ListsSettings/UpdateListItem";
import NewListItem from "@/components/SystemManagement/SystemSettings/ListsSettings/NewListItem";

import ImportView from "@/views/ImportView.vue"
import CustomFieldsView from "@/views/CustomFieldsView.vue"
import UsersView from "@/views/UsersView.vue"
import StockView from "@/views/StockView.vue"
import CompaniesView from "@/views/CompaniesView.vue"
import ListsView from "@/views/ListsView.vue"
import NetworkRulesView from "@/views/NetworkRulesView"
import IntegrationsView from "../views/IntegrationsView.vue";
import GlobalSearchView from "@/views/GlobalSearchView";
import TasksView from "@/views/TasksView";

import MultiSelect from "@/views/MultiSelect";
import SplicingView from "@/views/SplicingView";

import DirectoryView from "../views/DirectoryView.vue"
import MapsView from "../views/MapsView.vue";

import PageUnderConstruction from "@/views/PageUnderConstruction";
import PageNotFound from "@/views/PageNotFound";

import AssetReservationManagement from "@/views/AssetReservationManagement";
import AssetReservations from "@/components/AssetReservationManagement/Data/AssetReservations";
import ReservationDetails from "@/components/AssetReservationManagement/Data/ReservationDetails";
import AssetDetails from "@/components/AssetReservationManagement/Data/AssetDetails";
import ReservationTemplates from "@/components/AssetReservationManagement/Templates/ReservationTemplates";
import ReservationTemplateDetails from "@/components/AssetReservationManagement/Templates/ReservationTemplateDetails";
import ReservationTemplateCreateEdit from "@/components/AssetReservationManagement/Templates/ReservationTemplateCreateEdit";

import Support from "@/views/Support.vue";
import Tickets from "@/components/Support/TechnicalSupport/Tickets";
import TicketsDetails from "@/components/Support/TechnicalSupport/TicketsDetails";
import TicketCommentDetails from "@/components/Support/TechnicalSupport/TicketCommentDetails";
import SupportObjectCreateEdit from "@/components/Support/TechnicalSupport/SupportObjectCreateEdit";
import Wiki from "@/components/Support/Manuals/Wiki";

import Workspaces from "@/views/Workspaces";

import SoftwareLicenses from "@/views/SoftwareLicenses";
import Licenses from "@/components/User/Licenses/Licenses";

import CustomFields from "@/components/SystemManagement/SystemSettings/CustomFields/CustomFields";
import CustomFieldsDetails from "@/components/SystemManagement/SystemSettings/CustomFields/CustomFieldsDetails";
import CustomFieldsCreateEdit from "@/components/SystemManagement/SystemSettings/CustomFields/CustomFieldsCreateEdit";
import Network from "@/components/Network/Network";
import BusinessIntelligencePage from "@/views/BusinessIntelligencePage";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next("/hub");
  } else if (store.getters.hasToken) {
    next("/login-company");
  } else next();
};

const ifSemiAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next("/hub");
  } else if (!store.getters.hasToken) {
    next("/login");
  } else next();
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
  } else next("/login");
};

const userHasAdminOrSuperAdmin = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.isSuperAdmin) {
      next();
    } else if (store.getters.isAdmin) {
      userHasPermission(to, from, next);
    } else {
      next(from);
    }
  } else next("/login");
};

const userHasPermission = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.isSuperAdmin) {
      next();
    } else {
      if (
        (to.meta.permissions && hasAllNecessaryPermissions(to.meta.permissions)) ||
        (to.meta.permission && store.getters.userHasPermission(to.meta.permission))
      ) {
        next();
      } else next("/hub");
      return ;
    }
  } else next("/login");
};

const moduleIsActive = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.isSuperAdmin) {
      next();
    } else {
      let userPermissions = store.getters.getUserPermissions;
      let userModulePermissions = userPermissions.filter(permission => permission.type === "module");
      if (userModulePermissions) {
        let module = store.getters.modulesStates.find(
          module =>
            module.permission_name === "module_" + to.matched[0].meta.permission
        );
        if (module && module.status) {
          userHasModulePermission(to, from, next);
        } else next(from);
      } else {
        setTimeout(() => {
          moduleIsActive(to, from, next);
        }, 1000);
      }
    }
  } else next("/login");
};

const userHasModulePermission = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (store.getters.userHasPermission("module_" + to.matched[0].meta.permission)) {
      next();
    } else next("/hub");
  } else next("/login");
};

const hasAllNecessaryPermissions = (neededPermissions) => {
  let missingPermissionsList = [];
  if (neededPermissions) {
    neededPermissions.forEach(item => {
      if (!store.getters.userHasPermission(item)) {
        missingPermissionsList.push(item);
      }
    });
  } else {
    return true;
  }
  return missingPermissionsList.length === 0;
};

//////////
// por verificar


const getFirstAvailablePage = to => {
  const route = routes.find(item => item.name === to.name);
  if (route.children) {
    for (const child of route.children) {
      if (
        child.meta &&
        hasAllNecessaryPermissions(child.meta.permissions, child.meta.role)
      ) {
        return { name: child.name };
      }
    }
  }
  return { name: "hub" };
};


import endpoints from "../utils/endpoints";

const routes = [
  {
    path: "/oauth",
    name: "oauth",
    beforeEnter: function(){
      const urlSearchParams = new URLSearchParams(window.location.search);
      let params = Object.fromEntries(urlSearchParams.entries());
      params.token = localStorage.getItem("auth_token");
      const searchParams = new URLSearchParams(params);
      window.location.href = `${endpoints.AUTH_API_URL}pre_authorize?${searchParams}`
    }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    alias: "/",
    beforeEnter: ifNotAuthenticated
  },
  {
    path: "/login-company",
    name: "login-company",
    component: LoginCompanySelection,
    beforeEnter: ifSemiAuthenticated
  },
  {
    path: "/login-recovery-email",
    name: "login-recovery-email",
    component: LoginRecoveryEmail,
    beforeEnter: ifNotAuthenticated

  },
  {
    path: "/login-recovery-passwordreset/:bearer/:email",
    name: "login-recovery-passwordreset",
    component: LoginPasswordRecovery,
    beforeEnter: ifNotAuthenticated

  },
  {
    path: "/password-recovery",
    name: "recovery",
    component: recovery,
    beforeEnter: ifNotAuthenticated,
    props: true
  },
  {
    path: "/recovery-step-2",
    name: "recovery-step-2",
    component: recoveryStep2,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: "/recovery-step-3",
    name: "recovery-step-3",
    component: recoveryStep3,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: "/hub",
    name: "hub",
    component: Hub,
    beforeEnter: ifAuthenticated
  },
  {
    path: "/simulations",
    name: "simulations",
    component: SimulationsManagement,
    beforeEnter: moduleIsActive,
    children: [
      {
        path: "npv",
        name: "npv",
        component: NpvTable,
      },
      {
        path: "npv/configuration/:uuid",
        name: "Configuration",
        component: NpvConfiguration,
      },
      {
        path: "strategic",
        name: "strategic",
        component: Workspace,
      },
      {
        path: "configuration/npv",
        name: "configuration-npv",
        component: ConfigurationNpv,
      }
    ]
  },
  {
    path: "/data/import",
    name: "data-import",
    component: ImportsView,
    meta: {
      permissions: ["import_list"],
      role: "management"
    },
    beforeEnter: userHasPermission,
  },
  {
    path: "/global-search",
    name: "global-search",
    component: GlobalSearchView,
  },
  {
    path: "/data/deleteLayers",
    name: "data-deleteLayers",
    component: DeleteLayers
  },
  {
    path: "/stock-management",
    name: "stock-management",
    component: StockView,
    beforeEnter: moduleIsActive,
    meta: {
      permission: "stock_management"
    },
    // redirect: getFirstAvailablePage,
  },
  {
    path: "/integrations",
    name: "integrations",
    component: IntegrationsView,
    beforeEnter: userHasPermission,
    meta: {
      permissions: ["third_party_apis_service_list"]
    },
  },
  {
    path: "/directory",
    name: "directory",
    component: DirectoryView,
    beforeEnter: userHasPermission,
    meta: {
      permissions: ["workspace_list"]
    },
  },
  {
    path: "/companies",
    name: "companies",
    component: CompaniesView,
    meta: {
      permission: "company_list",
    },
    beforeEnter: userHasPermission,
  },
  {
    path: "/network-rules",
    name: "network-rules",
    component: NetworkRulesView,
    meta: {
      permission: "network_rule_list",
    },
    beforeEnter: userHasPermission,
  },
  {
    path: "/custom-fields",
    name: "custom-fields",
    component: CustomFieldsView,
    meta: {
      permission: "custom_field_list",
    },
    beforeEnter: userHasPermission,
  },
  {
    path: "/users",
    name: "users",
    component: UsersView,
    meta: {
      permission: "user_list",
    },
    beforeEnter: userHasPermission,
  },
  {
    path: "/roles",
    name: "client-roles",
    component: AccountRoles,
    meta: {
      permission: "role_list",
    },
    beforeEnter: userHasPermission,
  },
  {
    path: "/import",
    name: "import",
    component: ImportView,
    // meta: {
    //   permissions: ["import_mapper_list"],
    //   role: "management"
    // },
  },
  {
    path: "/lists",
    name: "list-settings",
    component: ListsView,
    meta: {
      permissions: ["list_list"],
    },
    beforeEnter: userHasPermission,
  },
  {
    path: "/multiselect/:workspaceUUID",
    name: "multiselect",
    component: MultiSelect
  },
  {
    path: "/splicing",
    name: "splicing",
    component: SplicingView,
  },
  {
    path: "/maps",
    name: "Maps",
    component: MapsView,
    meta: {
      permissions: ["third_party_apis_consumables_list"]
    },
    beforeEnter: userHasPermission
  },
  {
    path: "/tasks-management",
    name: "tasks-management",
    component: TasksView,
    meta: {
      permission: "field_management"
    },
    beforeEnter: userHasPermission,
  },
  {
    path: "/asset-reservation-management",
    name: "asset-reservation-management",
    component: AssetReservationManagement,
    beforeEnter: moduleIsActive,
    meta: {
      permission: "asset_reservation"
    },
    redirect: getFirstAvailablePage,
    children: [
      {
        path: "management/asset-reservation",
        name: "asset-reservations",
        component: AssetReservations,
        meta: {
          permissions: ["asset_reservation_list"],
          role: "fibercloud_web"
        },
        beforeEnter: userHasPermission,
        children: [
          {
            path: ":uuid",
            name: "asset-reservation",
            component: ReservationDetails,
            meta: {
              permissions: ["asset_reservation_show"],
              role: "fibercloud_web"
            },
            beforeEnter: userHasPermission
          },
          {
            path: ":uuid/associated-objects/:objectUuid",
            name: "associated-objects",
            component: AssetDetails,
            meta: {
              permissions: ["asset_reservation_object_show"],
              role: "fibercloud_web"
            },
            beforeEnter: userHasPermission
          }
        ]
      },
      {
        path: "management/import",
        name: "asset-reservation-import",
        component: PageUnderConstruction
      },
      {
        path: "management/export",
        name: "asset-reservation-export",
        component: PageUnderConstruction
      },
      {
        path: "templates/reservation-templates",
        name: "reservation-templates",
        component: ReservationTemplates,
        meta: {
          permissions: ["asset_reservation_template_list"],
          role: "fibercloud_web"
        },
        beforeEnter: userHasPermission,
        children: [
          {
            path: "create",
            name: "reservation-template-create",
            component: ReservationTemplateCreateEdit,
            meta: {
              permissions: ["asset_reservation_template_store"],
              role: "management"
            },
            beforeEnter: userHasPermission
          },
          {
            path: ":uuid",
            name: "reservation-template",
            component: ReservationTemplateDetails,
            meta: {
              permissions: ["asset_reservation_template_show"],
              role: "management"
            },
            beforeEnter: userHasPermission
          },
          {
            path: ":uuid/edit",
            name: "reservation-template-edit",
            component: ReservationTemplateCreateEdit,
            meta: {
              permissions: ["asset_reservation_template_update"],
              role: "management"
            },
            beforeEnter: userHasPermission
          }
        ]
      }
    ]
  },
  {
    path: "/business-intelligence",
    name: "business-intelligence",
    component: BusinessIntelligencePage,
    meta: {
      permission: "business_intelligence"
    },
    beforeEnter: moduleIsActive,
    redirect: getFirstAvailablePage,
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: DashboardPage,
        meta: {
          permissions: ["report_show"],
          role: "management"
        },
        beforeEnter: userHasPermission
      }
    ]
  },
  {
    path: "/network",
    name: "network",
    component: Network,
    beforeEnter: moduleIsActive,
    meta: {
      permission: "network"
    }
  },
  {
    path: "/workspaces/:workspace_uuid/@:long,:lat,:zoom\\z",
    name: "home",
    props: true,
    component: Home,
    beforeEnter: moduleIsActive,
    meta: {
      permission: "design"
    }
  },
  {
    path: "/workspaces",
    name: "workspaces",
    component: Workspaces,
    beforeEnter: moduleIsActive,
    meta: {
      permission: "design"
    }
  },
  {
    path: "/support",
    name: "support",
    component: Support,
    beforeEnter: moduleIsActive,
    meta: {
      permission: "support"
    },
    redirect: getFirstAvailablePage,
    children: [
      {
        path: "technical-support/tickets",
        name: "tickets",
        component: Tickets,
        meta: {
          permissions: ["third_party_apis_youtrack_issues_list"],
          role: "management"
        },
        beforeEnter: userHasPermission,
        children: [
          {
            path: "create",
            name: "tickets-create",
            component: SupportObjectCreateEdit,
            meta: {
              permissions: ["third_party_apis_youtrack_issues_store"],
              role: "management"
            },
            beforeEnter: userHasPermission
          },
          {
            path: ":id",
            name: "tickets-view",
            component: TicketsDetails,
            meta: {
              permissions: ["third_party_apis_youtrack_issues_show"],
              role: "management"
            },
            beforeEnter: userHasPermission
          },
          {
            path: ":id/edit",
            name: "tickets-edit",
            component: SupportObjectCreateEdit,
            meta: {
              permissions: ["third_party_apis_youtrack_issues_update"],
              role: "management"
            },
            beforeEnter: userHasPermission
          },
          {
            path: ":id/comments/create",
            name: "comments-create",
            component: SupportObjectCreateEdit,
            meta: {
              permissions: ["third_party_apis_youtrack_comments_store"],
              role: "management"
            },
            beforeEnter: userHasPermission
          },
          {
            path: ":id/comments/:commentId",
            name: "comment-view",
            component: TicketCommentDetails,
            meta: {
              permissions: ["third_party_apis_youtrack_comments_show"],
              role: "management"
            },
            beforeEnter: userHasPermission
          },
          {
            path: ":id/comments/:commentId/edit",
            name: "comments-edit",
            component: SupportObjectCreateEdit,
            meta: {
              permissions: ["third_party_apis_youtrack_comments_update"],
              role: "management"
            },
            beforeEnter: userHasPermission
          }
        ]
      },
      {
        path: "references",
        name: "references",
        component: PageUnderConstruction,
        meta: {
          permissions: [] // alterar para as permissões corretas quando estiverem criadas e inserir o role
        },
        beforeEnter: userHasPermission
      },
      {
        path: "wiki",
        name: "wiki",
        component: Wiki,
        meta: {
          permissions: [] // alterar para as permissões corretas quando estiverem criadas e inserir o role
        },
        beforeEnter: userHasPermission
      }
    ]
  },
  {
    path: "/software-licenses",
    name: "software-licenses",
    component: SoftwareLicenses,
    redirect: { name: "about-licenses" },
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "about/licenses",
        name: "about-licenses",
        component: Licenses
      }
    ]
  },
  { path: "*", component: PageNotFound, beforeEnter: ifAuthenticated }
];

export default new Router({
  hashbang: false,
  routes: routes
});



// WEBPACK FOOTER //
// ./src/router/index.js